import React from 'react';

const SearchSort: React.FunctionComponent = (props: any) => {
  const service = props.service;
  return <div data-hideable className="sort-container" {...{ [`data-${service}`]: '' }} data-widget="sort"></div>;
};

export default SearchSort;
